import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AvailableUserGroupsUpdated } from './user-groups.actions';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { AvailableUserGroupRemoteDto } from 'src/generated/signalR/available-user-group-remote-dto';

export interface UserGroupsStateModel {
   availableGroups: AvailableUserGroupRemoteDto[];
}

@State<UserGroupsStateModel>({
   name: 'userGroups',
   defaults: {
      availableGroups: [],
   },
})
@Injectable()
export class UserGroupsState {
   constructor() {}

   @Selector([UserGroupsState])
   public static getAvailableUserGroups(state: UserGroupsStateModel): AvailableUserGroupRemoteDto[] {
      return state.availableGroups;
   }

   @Selector([UserGroupsState])
   public static getGroupForId(state: UserGroupsStateModel): (groupId: number) => null | AvailableUserGroupRemoteDto {
      return (groupId: number) => {
         return _(state.availableGroups)
            .filter((x) => x.id === groupId)
            .head();
      };
   }

   @Action(AvailableUserGroupsUpdated)
   public updateAvailableUserGroups(ctx: StateContext<UserGroupsStateModel>, action: AvailableUserGroupsUpdated) {
      ctx.patchState({
         availableGroups: action.data.availableUserGroups,
      });
   }
}
